/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Typography, Collapse, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core'
import AddButton from './AddButton';
import RemoveButton from './RemoveButton'
import Condition from './Condition'

import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import  IconButton  from '@material-ui/core/IconButton';

const styles = theme => ({

})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        // primary: {
        //     main: "#FF6600",  
        //     contrastText: "#FFFFFFFF"
        // },
        secondary: {
            main: '#f50157',
        },
      },
})

class BooleanOp extends Component {
    state = {
        open : true
    }

    renderChildren = () => {
        let children = this.props.config.operands.map((child, i) => {
            if (child.boolop !== 'leaf') {
                return (
                    <BooleanOp 
                        key = {this.props.id + '/' + (this.props.step + 1) + '-' +(i)} 
                        id = {this.props.id + '/' + (this.props.step + 1) + '-' +(i)} 
                        step = {this.props.step + 1} 
                        index = {i} 
                        config = {child} 
                        addOp = {this.props.addOp}
                        removeOp = {this.props.removeOp}
                        updateObj = {(obj, key_path, value) => this.props.updateObj(obj, key_path, value)}
                        field_config = {this.props.field_config}
                        operator_config = {this.props.operator_config}
                        operator_params_config = {this.props.operator_params_config}
                        ic_name = {this.props.ic_name} 
                        iu_name = {this.props.iu_name}
                        edit = {this.props.edit}
                        ws_name = {this.props.ws_name}
                    />
                )
            } else {
                return (
                    <Condition 
                        id = {this.props.id + '/' + (this.props.step + 1) + (i)} 
                        key = {this.props.step} 
                        step = {this.props.step + 1} 
                        index = {i} 
                        config = {child}
                        ic_name = {this.props.ic_name} 
                        iu_name = {this.props.iu_name}
                        field_config = {this.props.field_config}
                        operator_config = {this.props.operator_config}
                        operator_params_config = {this.props.operator_params_config}
                        updateObj = {(obj, key_path, value) => this.props.updateObj(obj, key_path, value)}
                        disabled = {!this.props.edit}
                        ws_name = {this.props.ws_name}
                    />
                )
            }
        })

        return children
    }

    renderIcon = () => {
        if (this.state.open === true) {
            return (
                <div style = {{marginRight: '10px'}}>
                    <IconButton size = 'small' onClick = {this.handleToggle}>
                        <ExpandLess/>
                    </IconButton>
                </div>
            )
        } else {
            return (
                <div style = {{marginRight: '10px'}}>
                    <IconButton size = 'small' onClick = {this.handleToggle}>
                        <ExpandMore/>
                    </IconButton>
                </div>
            )
        }
    }

    renderOperationSelection = () => {
        return (
            <div style = {{flexGrow: 1}}>
                <div style = {{width : '15%'}}>
                    <FormControl 
                        key = {this.props.config.id} 
                        size = 'small' 
                        fullWidth variant = 'outlined'
                        disabled = {!this.props.edit}
                    >
                        <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.props.config.boolop}
                        onChange = {(event) => this.props.updateObj(this.props.config, ['boolop'], event.target.value)}
                        >
                            <MenuItem value = 'and'>AND</MenuItem>
                            <MenuItem value = 'or'>OR</MenuItem>
                        </Select>
                        <FormHelperText>Logical Operator</FormHelperText>
                    </FormControl>
                </div>
            </div>
        )
    }

    handleToggle = () => {
        this.setState({...this.state, open : !this.state.open})
    }

    renderActions = () => {
        return (
            <Fragment>

            </Fragment>
        )
    }

    render() {
        const { classes } = this.props
        return (
                <div style = {{
                    backgroundColor : '#ECFBFF', 
                    border: this.props.edit === true ? '1px solid rgba(0, 199, 255, 1.0)' : '1px solid rgba(0, 199, 255, 0.5)', 
                    borderRadius :'5px',
                    boxShadow : this.props.edit === true ? '0 4px 8px 0 rgba(0, 0, 0, 0.1)' : '', 
                    margin: '5px', 
                    marginLeft : '15px'
                }}>
                    <div style ={{width : '100%', margin : '5px', display : 'flex', flexDirection : 'row'}}>
                        {this.renderOperationSelection()}
                        {this.renderIcon()}
                    </div>
                    <Collapse in = {this.state.open}>
                        {/* <Typography>{this.props.config.id}</Typography> */}
                        {this.renderChildren()}
                        <AddButton 
                            key = {this.props.id} 
                            cur_id = {this.props.id} 
                            role = 'trigger' 
                            step = {this.props.step} 
                            index = {this.props.index} 
                            tag = 'Operand' 
                            addBoolOp = {this.props.addOp}
                            disabled = {!this.props.edit}
                        />
                        <RemoveButton 
                            key = {this.props.id} 
                            cur_id = {this.props.id} 
                            role = 'trigger' 
                            step = {this.props.step} 
                            index = {this.props.index} 
                            tag = 'Operand' 
                            removeBoolOp = {this.props.removeOp}
                            disabled = {!this.props.edit}
                        />
                    </Collapse>
                </div>
        );
    }
}

export default withStyles(styles)(BooleanOp);